import { addMouseEventHandling } from "./addMouseEventHandling";

export function addPath(
  specificCarLatLong,
  color,
  item,
  carIndex,
  mapData,
  mapsData,
  specificCarHistoryData,
  historyOptions,
  polyLinesData,
  setHoverStateHistory,
  setPolyLineState,
  carHistoryList
) {
  let red = "#FF0000";
  let yellow = "#FFFF00";

  let WARNING_MARKER_Z_INDEX = 110;
  let CRTICAL_MARKER_Z_INDEX = 120;
  let NORMAL_CAR_HISTORY_Z_INDEX = 20;

  let NumOfSelectedCarsForHistory = specificCarHistoryData
    ? Object.keys(specificCarHistoryData).length
    : 0;
  if (specificCarLatLong.length > 1) {
    var zIndexToUse =
      historyOptions !== 4
        ? color === red
          ? CRTICAL_MARKER_Z_INDEX
          : color === yellow
          ? WARNING_MARKER_Z_INDEX
          : NORMAL_CAR_HISTORY_Z_INDEX
        : color === red
        ? NORMAL_CAR_HISTORY_Z_INDEX
        : color === yellow
        ? WARNING_MARKER_Z_INDEX
        : CRTICAL_MARKER_Z_INDEX;

    var flightPath =
      mapsData &&
      new mapsData.Polyline({
        path: specificCarLatLong,
        strokeColor: color,
        strokeOpacity:
          NumOfSelectedCarsForHistory > 1
            ? historyOptions === 4
              ? 0.35
              : 1
            : 1,
        strokeWeight: NumOfSelectedCarsForHistory > 1 ? 3 : 5,
        zIndex: zIndexToUse,
      });
    if (flightPath) {
      flightPath.setMap(mapData);
      flightPath.car = item[0][0].CarNumber;
      flightPath.strokeColorUsed = color;
      flightPath.zIndexUsed = zIndexToUse;
      flightPath.strokeOpacityUsed = flightPath.strokeOpacity;
      flightPath.isHoveredOver = false;
      polyLinesData.push(flightPath);
    }
    addMouseEventHandling(
      flightPath,
      mapsData,
      specificCarHistoryData,
      setHoverStateHistory,
      polyLinesData,
      setPolyLineState,
      carHistoryList
    );
  }
}
